import { AddDiscountCodeStatus } from '@spa/lib/store/carts/CartsState';

const convertAddDiscountCodeStatus = (value: string): AddDiscountCodeStatus => {
  return (
    Object.values(AddDiscountCodeStatus).find((status) => status === value) ??
    AddDiscountCodeStatus.NOT_APPLIED
  );
};

export default convertAddDiscountCodeStatus;
